// Copyright © 2021 Move Closer
/**
 * Filter that trim string to given length.
 *
 * @param  {String} value
 * @param length
 * @param add
 * @return {String}
 */
export default function (value, length = 25, add = '...') {
    return (value.length > length) ? `${value.slice(0, length)}${add}` : value;
}
